<template>
    <div>
        <b-message v-if="setting">Configurando equipamento...</b-message>
        <b-message v-else type="is-danger" has-icon>
            {{ error }}
            <p v-if="retryLoading"><b-button loading disabled rounded /></p>
            <small v-if="errorDetail"><br /><code>{{  errorDetail  }}</code></small>
        </b-message>
    </div>
</template>

<script>
import api from '@/api.js'

export default {
    name: 'setup',

    data() {
        return {
            setting: true,
            error: '',
            errorDetail: '',
            retryLoading: false,
        }
    },

    mounted() {
        const equipmentId = this.$route.params.equipmentId
        const secret = this.$route.params.secret
        let credential = null

        if (!equipmentId) {
            this.error = 'Equipamento não informado!'
            this.setting = false
            return
        }

        if (!secret) {
            this.error = 'Código de autorização não informado!'
            this.setting = false
            return
        }

        /**
         * Formato do código de autorização esperado:
         * String em base64 com o conteúdo:
         * { "oauth": { "client_id": "", "client_secret": "" }}
         */
        try {
            credential = JSON.parse(Buffer.from(secret, 'base64').toString('ascii'))
            if (!credential.oauth) {
                throw new Error('Indice oauth não encontrado no secret!')
            }
            if (!credential.oauth.client_id) {
                throw new Error('Indice oauth.client_id não encontrado no secret!')
            }
            if (!credential.oauth.client_secret) {
                throw new Error('Indice oauth.client_secret não encontrado no secret!')
            }
        } catch (e) {
            console.log('Formato do código de autorização inválido!', e)
            this.error = 'Formato do código de autorização inválido!'
            this.setting = false
            return
        }

        this.$store.commit('setCredential', credential.oauth)
        this.requestAppAccessToken(equipmentId)
    },

    methods: {
        requestAppAccessToken(equipmentId) {
            this.setting = true
            this.error = ''
            this.errorDetail = ''
            this.retryLoading = false

            api.requestAppAccessToken().then(r => {
                this.$store.commit('setAuthorizationApp', r)

                const options = {
                    url: 'equipment/search',
                    method: 'get',
                    params: {
                        q: JSON.stringify({
                            with: ['place.unit'],
                            filters: [{
                                conditions: [{
                                    field: 'id',
                                    value: equipmentId,
                                }]
                            }]
                        }),
                    },
                    loading: false
                }
                
                api.appRequest(options).then(({ data }) => {
                    if (data && data.length) {
                        if (data.length == 1) {
                            const equipment = data[0]
                            if (equipment.enabled) {
                                if (equipment.place.unit.enabled) {
                                    this.$store.commit('setEquipment', equipment)
                                    this.$router.push('/')
                                } else {
                                    this.error = `Unidade (#${equipment.place.unit.id}) desabilitada!`
                                    this.setting = false
                                }
                            } else {
                                this.error = `Equipamento (#${equipmentId}) desabilitado!`
                                this.setting = false
                            }
                        } else {
                            this.error = `Equipamento (#${equipmentId}) não identificado corretamente!`
                            this.setting = false
                        }
                    } else {
                        this.error = `Equipamento (#${equipmentId}) não encontrado!`
                        this.setting = false
                    }
                }).catch(e => {
                    console.log(`Equipamento (#${equipmentId}) inválido!`, e)
                    this.error = `Equipamento (#${equipmentId}) inválido!`
                    this.errorDetail = e.message
                    this.setting = false
                })
            }).catch(e => {
                const retrySecs = 10
                console.log(`Falha ao obter autorização (#${equipmentId})!`, e)
                this.error = `Falha ao obter autorização (#${equipmentId})! Tentando novamente dentro de ${retrySecs} segundos.`
                this.errorDetail = e
                this.setting = false
                this.retryLoading = true

                setTimeout(() => {
                    this.error = ''
                    this.errorDetail = ''
                    setTimeout(() => this.requestAppAccessToken(equipmentId), 1500)
                }, retrySecs * 1000)
            })
        }
    }
}
</script>